import {Component, OnDestroy, OnInit, Input, ViewChild, Output, EventEmitter} from '@angular/core';
import {UIRouter} from '@uirouter/angular';
import {DatatableViewComponent} from '@ngx-ivengi/crud';
import {ConfirmationModalComponent} from '../confirmation/confirmation-modal.component';
import {FileService} from '../file/file.service';
import {Warranty} from './warranty.model';
import {WarrantyService} from './warranty.service';
import {RoutePrefix} from '../shared/route-prefix';

@Component({
  selector: 'app-warranty-datatable',
  templateUrl: './warranty-datatable.component.html'
})
export class WarrantyDatatableComponent extends DatatableViewComponent<Warranty> implements OnDestroy, OnInit {
  public assignmentType: string;

  @ViewChild(ConfirmationModalComponent)
  public confirmationModal: ConfirmationModalComponent;

  @Output() onWarrantiesLoaded = new EventEmitter<any>();
  @Input() public linkView: boolean = false;
  @Input() public routePrefix: RoutePrefix | RoutePrefix[];
  @Input() public displayActions: boolean = true;

  public entityType: string;

  constructor(
    protected router: UIRouter,
    protected warrantyService: WarrantyService,
    protected fileService: FileService
  ) {
    super(warrantyService);
  }

  public ngOnDestroy(): void {
    this.warrantyService.clearRoutePrefix();
  }

  ngOnInit(): void {
    if(this.routePrefix) {
      const matches = this.router.stateService.$current.name.match(/^\w+\.(\w+).*$/);
      this.assignmentType = matches[1] || '';

      const prefixParts = (this.routePrefix instanceof Array) ? this.routePrefix : [this.routePrefix];

      const prefix  = prefixParts.map((item) => {
        return `${item.entity}/${item.entityId}`;
      });

      this.warrantyService.setRoutePrefix(prefix.join('/').toLowerCase());
    }

    this.fetchData();
  }

  public fetchData(): void {
    this.loading  = true;
    this.warrantyService.getAll(this.requestParams).map((warranties: Warranty[]) => {
      return warranties.map((warranty) => {
        warranty.setFileSrc(this.fileService.getLinkById(warranty.fileId));
        return warranty;
      });
    }).subscribe((warranties: Warranty[]) => {
      this.rows = warranties;
      this.loading = false;
      this.onWarrantiesLoaded.emit({type: this.entityType, items: this.rows});
    });
  }

  public deleteItem(item) {
    this.confirmationModal.show(item);
  }

  public onDeleteConfirmation(event) {
    if(event.confirmed === true) {
      this.warrantyService.delete(event.data).subscribe(() => {
        this.router.stateService.go(this.router.stateService.$current.name, this.router.stateService.params, {reload: true});
      });
    }
  }

  public onRowClick(event) {
    if (event.type !== 'dblclick' || typeof event.column === 'undefined' || event.column.prop === 'menu' || typeof event.row === 'undefined') {
      return;
    }
    this.router.stateService.go('assignment.' + this.assignmentType + '.edit.warranty.edit', { warrantyId: event.row.id }, { reload: true });
  }}




// WEBPACK FOOTER //
// /var/jenkins_home/workspace/brands-compart-portal-frontend/checkout/src/app/components/warranty/warranty-datatable.component.ts